// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.orderCard_cover__gIv7P {
  padding: 0; }

.orderCard_header__PfSzd {
  padding: 10px;
  border-bottom: 1px solid var(--Gray88);
  background-color: var(--White); }
  .orderCard_header__PfSzd .orderCard_titleWrapper__4YUjD {
    width: 100%;
    display: flex;
    justify-content: space-between; }
    .orderCard_header__PfSzd .orderCard_titleWrapper__4YUjD .orderCard_titleContent__O1eom {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      gap: 5px;
      margin-bottom: 20px; }
      .orderCard_header__PfSzd .orderCard_titleWrapper__4YUjD .orderCard_titleContent__O1eom .orderCard_title__l9b67 {
        font-weight: 700;
        font-size: 18px;
        line-height: 24px;
        color: var(--HightEmphasis); }
    .orderCard_header__PfSzd .orderCard_titleWrapper__4YUjD .orderCard_orderDate__PoUsy {
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: var(--HightEmphasis); }

.orderCard_subtitle__Zfh3x {
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: var(--HightEmphasis); }
  .orderCard_subtitle__Zfh3x .orderCard_customer__ZKRkv {
    font-weight: 500; }

.orderCard_list__BN-zP {
  height: calc(100vh - 260px);
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 20px;
  padding-left: 10px;
  padding-bottom: 10px;
  margin-right: 7px;
  overflow-y: scroll; }

.orderCard_list__BN-zP::-webkit-scrollbar {
  width: 8px;
  background-color: inherit; }

.orderCard_list__BN-zP::-webkit-scrollbar-thumb {
  background: var(--Gray88);
  border-radius: 20px; }

.orderCard_list__BN-zP::-webkit-scrollbar-track {
  background-color: inherit; }
`, "",{"version":3,"sources":["webpack://./src/pages/previewOrders/components/OrderCard/orderCard.module.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAEA;EACE,UAAU,EAAA;;AAGZ;EACE,aAAa;EACb,sCAAsC;EACtC,8BAA8B,EAAA;EAHhC;IAMI,WAAW;IACX,aAAa;IACb,8BAA8B,EAAA;IARlC;MAWM,WAAW;MACX,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,QAAQ;MACR,mBAAmB,EAAA;MAhBzB;QCOE,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QDWX,2BAA2B,EAAA;IApBnC;MCaE,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MDWb,2BAA2B,EAAA;;AAKjC;ECME,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EDNjB,2BAA2B,EAAA;EAF7B;IAKI,gBAAgB,EAAA;;AAIpB;EACE,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB,EAAA;;AAGpB;EACE,UAAU;EACV,yBAAyB,EAAA;;AAG3B;EACE,yBAAyB;EACzB,mBAAmB,EAAA;;AAGrB;EACE,yBAAyB,EAAA","sourcesContent":["@import 'src/styles/fonts';\n\n.cover {\n  padding: 0;\n}\n\n.header {\n  padding: 10px;\n  border-bottom: 1px solid var(--Gray88);\n  background-color: var(--White);\n\n  .titleWrapper {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n\n    .titleContent {\n      width: 100%;\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      gap: 5px;\n      margin-bottom: 20px;\n\n      .title {\n        @include h3;\n        color: var(--HightEmphasis);\n      }\n    }\n\n    .orderDate {\n      @include h4;\n      color: var(--HightEmphasis);\n    }\n  }\n}\n\n.subtitle {\n  @include body2;\n  color: var(--HightEmphasis);\n\n  .customer {\n    font-weight: 500;\n  }\n}\n\n.list {\n  height: calc(100vh - 260px);\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding-top: 20px;\n  padding-left: 10px;\n  padding-bottom: 10px;\n  margin-right: 7px;\n  overflow-y: scroll;\n}\n\n.list::-webkit-scrollbar {\n  width: 8px;\n  background-color: inherit;\n}\n\n.list::-webkit-scrollbar-thumb {\n  background: var(--Gray88);\n  border-radius: 20px;\n}\n\n.list::-webkit-scrollbar-track {\n  background-color: inherit;\n}\n","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cover": `orderCard_cover__gIv7P`,
	"header": `orderCard_header__PfSzd`,
	"titleWrapper": `orderCard_titleWrapper__4YUjD`,
	"titleContent": `orderCard_titleContent__O1eom`,
	"title": `orderCard_title__l9b67`,
	"orderDate": `orderCard_orderDate__PoUsy`,
	"subtitle": `orderCard_subtitle__Zfh3x`,
	"customer": `orderCard_customer__ZKRkv`,
	"list": `orderCard_list__BN-zP`
};
export default ___CSS_LOADER_EXPORT___;
